import React, { useState, useEffect } from 'react';
import { View, Text, ActivityIndicator, StyleSheet } from 'react-native';
import { useNavigate } from 'react-router-dom';

const DeviceRouter = () => {
  const navigate = useNavigate();
  const [detecting, setDetecting] = useState(true);

  useEffect(() => {
    console.log('🔍 Detecting device type...');
    
    // Detect device type
    const isMobile = /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
    
    // Additional check for tablet/small desktop
    const isTablet = /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(
      navigator.userAgent
    );
    
    // Screen size check (as backup)
    const screenWidth = window.innerWidth;
    const isMobileScreen = screenWidth < 768;
    
    // Final determination
    const isMobileDevice = isMobile || (isTablet && isMobileScreen) || isMobileScreen;
    
    console.log('Device detection results:');
    console.log('  User Agent Mobile:', isMobile);
    console.log('  User Agent Tablet:', isTablet);
    console.log('  Screen Width:', screenWidth);
    console.log('  Is Mobile Screen:', isMobileScreen);
    console.log('  Final Decision:', isMobileDevice ? 'MOBILE' : 'DESKTOP');
    
    // Route based on device type
    setTimeout(() => {
      // Always route to mobile view for development
      console.log("📱 Routing to mobile view (Today) - Development Mode");
      navigate("/today");
      setDetecting(false);
    }, 300); // Brief delay for smooth transition
    
  }, [navigate]);

  if (detecting) {
    return (
      <View style={styles.container}>
        <ActivityIndicator size="large" color="#0E7C6B" />
        <Text style={styles.text}>Detecting device...</Text>
      </View>
    );
  }

  return null;
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#F6F8F7',
  },
  text: {
    marginTop: 20,
    fontSize: 16,
    color: '#5C6B68',
  },
});

export default DeviceRouter;

